import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { NbDialogService } from "@nebular/theme";
import { map } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { find, remove, clone, sortBy } from "lodash";

import { Router } from "@angular/router";

import Notification from "../../models/notification.model";

import { NotificationService } from "../../services/notifications.service";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { convertTimestampsPipe } from "../../@core/utils/convertTimestamps.service";
import { WhereList } from "../../models/pagination";

@Component({
  selector: "ngx-view-notifications",
  styleUrls: ["./view-notifications.component.scss"],
  templateUrl: "./view-notifications.component.html",
})
export class ViewNotificationsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "admin"; //admin / develop // tutor / home / qnas
  @Input() courseId?: string = "";
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  submitted = false;
  loading = false;
  cursor: any;
  done = false;
  init = false;

  display?: Notification[] = [];
  notisFirst?: Notification[] = [];
  notisMore?: Notification[] = [];

  wheres: WhereList[] = [];
  pageSize = 3;
  uid = "anonymous";

  constructor(
    private notificationService: NotificationService,
    public userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        if (this.mode === "qnas") {
          this.getQnAReplyNotifications();
        } else {
          this.getFirst();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getQnAReplyNotifications() {
    this.loading = true;
    this.notificationService
      .getQnAReplyNotifications(this.uid)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (!this.cursor && data.length > 0) {
          this.cursor = data[data.length - 1].doc;
        }

        data.forEach((noti) => {
          //get icon
          this.getIconType(noti);
          this.getIconMode(noti);
          noti.createdOn = convertTimestamp(noti.createdOn);

          let item = find(this.notisFirst, ["id", noti.id]);
          if (item) {
            item = noti;
          } else {
            if (this.init) {
              this.notisFirst = [noti, ...this.notisFirst];
            } else {
              this.notisFirst.push(noti);
            }
          }
        });

        this.display = [...this.notisFirst, ...this.notisMore];
        this.loading = false;
        this.init = true;
      });
  }

  getFirst(): void {
    this.loading = true;

    this.notificationService
      .getFirst(this.uid, this.courseId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (!this.cursor && data.length > 0) {
          this.cursor = data[data.length - 1].doc;
        }

        data.forEach((noti) => {
          //get icon
          this.getIconType(noti);
          this.getIconMode(noti);
          noti.createdOn = convertTimestamp(noti.createdOn);

          let item = find(this.notisFirst, ["id", noti.id]);
          if (item) {
            item = noti;
          } else {
            if (this.init) {
              this.notisFirst = [noti, ...this.notisFirst];
            } else {
              this.notisFirst.push(noti);
            }
          }
        });

        this.display = [...this.notisFirst, ...this.notisMore];
        this.loading = false;
        this.init = true;

        // console.log("ViewNotificationsComponent/first:", this.display);
      });
  }

  getMore(): void {
    this.pageSize = 10;
    this.getNotifications();
  }

  close(value) {
    this.onClose.emit(true);
  }

  onDelete(value) {
    if (value) {
      remove(this.notisMore, (e) => {
        return e.id == value;
      });
      this.display = [...this.notisMore];
    }
  }

  private getNotifications(): void {
    this.loading = true;

    this.wheres = [];
    this.wheres.push({
      fieldPath: "toUid",
      value: this.uid,
    });

    if (this.courseId && this.courseId != "") {
      this.wheres.push({
        fieldPath: "courseId",
        value: this.courseId,
      });
    }

    if (this.mode == "qnas") {
      this.wheres.push({
        fieldPath: "type",
        value: "Trả lời",
      });
    }

    this.notificationService
      .getNotifications(this.wheres, this.pageSize, this.cursor)
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new Notification();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            //get icon
            this.getIconType(data);
            this.getIconMode(data);

            let item = find(this.notisMore, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.notisMore.push(data);
            }
          });

          this.display = [...this.notisFirst, ...this.notisMore];

          // console.log("ViewNotificationsComponent/more:", this.display);
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  }

  private getIconType(data) {
    switch (data.type) {
      case "Thích":
        data.iconType = "liked";
        break;
      case "Bình luận":
        data.iconType = "message-square-outline";
        break;
      case "Báo xấu":
        data.iconType = "alert-triangle-outline";
        break;
      case "Làm bài":
        data.iconType = "play-circle-outline";
        break;
      case "Học bài":
        data.iconType = "checkmark-circle-outline";
        break;
      default:
        data.iconType = "bell-outline";
        break;
    }
  }

  private getIconMode(data) {
    switch (data.mode) {
      case "courses":
        data.iconMode = "book-open-outline";
        data.navigateUrl = "/course/" + data.refId;
        data.preTitle = "khóa học";
        break;
      case "lecture-contents":
        data.iconMode = "file-text-outline";
        data.navigateUrl = "/lecture/" + data.refId;
        data.preTitle = "bài viết";
        break;
      case "exercises":
        data.iconMode = "award-outline";
        data.navigateUrl = "/exercise/" + data.refId;
        data.preTitle = "thử thách";
        break;
      case "qnas":
        data.iconMode = "question-mark-circle-outline";
        data.navigateUrl = "/qna/" + data.refId;
        data.preTitle = "";
        break;
      case "quizzes":
        data.iconMode = "layers-outline";
        data.navigateUrl = "/quiz/" + data.refId;
        data.preTitle = "câu đố";
        break;
      case "comments":
        data.iconMode = "message-square-outline";
        data.navigateUrl = "";
        data.preTitle = "bình luận";
        break;
      case "report-spams":
        data.iconMode = "alert-triangle-outline";
        data.navigateUrl = "";
        data.preTitle = "báo xấu";
        break;
      case "feedbacks":
        data.iconMode = "bulb-outline";
        data.navigateUrl = "";
        data.preTitle = "góp ý";
        break;
      case "exercise-users":
        data.iconMode = "award-outline";
        data.navigateUrl = "/exercise/" + data.refId;
        data.preTitle = "thử thách";
        break;

      default:
        if (data.mode.includes("courses/")) {
          data.iconMode = "book-open-outline";
          data.navigateUrl = "/course/" + data.mode.split("/")[1];
          data.preTitle = "khóa học";
        } else if (data.mode.includes("qnas/")) {
          data.iconMode = "question-mark-circle-outline";
          data.navigateUrl = "/qna/" + data.mode.split("/")[1];
          data.preTitle = "câu hỏi";
        } else if (data.mode.includes("enrollments/")) {
          data.iconMode = "book-open-outline";
          data.navigateUrl = "";
          data.preTitle = "";
        } else {
          data.iconMode = "globe-outline";
          data.navigateUrl = "";
          data.preTitle = "";
        }

        break;
    }
  }
}
